<ion-content>
  <ion-fab vertical="top" horizontal="end" slot="fixed" (click)="closeAlert()">
    <ion-fab-button class="main-button" color="white" size="small">
      <ion-icon name="close"></ion-icon>
    </ion-fab-button>
  </ion-fab>

  <ion-grid class="alert-wrapper">
    <ion-row>

      <ion-col class="ion-text-center" size="12">
        <img *ngIf="icon" class="alert-image" alt="logo" src="{{iconsPath}}{{icon}}.svg">
        <h2 class="title secondary-text"><strong>{{ title }}</strong></h2>
        <h2 *ngIf="subtitle" class="subtitle primary-text">{{ subtitle }}</h2>
        <h5 class="message secondary-text">{{ message }}</h5>
      </ion-col>

      <ion-col class="ion-text-center" size="12" *ngIf="input">
        <ion-item class="border-input-round">
          <img src="{{iconsPath}}{{input.icon}}.svg" alt="" class="ion-padding-end" *ngIf="input.icon">
          <ion-input name="input" [type]="input.type" [(ngModel)]="input.value" [placeholder]="input.placeholder || ''" [maxlength]="input.maxLength || '256'"></ion-input>
        </ion-item>
      </ion-col>

      <ion-col class="button-container" size="12" *ngIf="buttons && buttons.length > 0">
        <ion-button *ngFor="let button of buttons" [fill]="button.fill" [color]="button.color"
          (click)="closeAlert(button.action)" class="alert-button">
          {{ button.text }}
        </ion-button>
      </ion-col>

      <ion-col *ngIf="!buttons" class="button-container" size="12">
        <ion-button (click)="closeAlert()" class="dismiss-button">
          Entendido
        </ion-button>
      </ion-col>

    </ion-row>
  </ion-grid>
</ion-content>